'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CampaignsController = function () {
    function CampaignsController($scope, $state, $ionicLoading, ApiCampaigns, $ionicScrollDelegate, $stateParams) {
        _classCallCheck(this, CampaignsController);

        this.ApiCampaigns = ApiCampaigns;
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.campaigns = [];
        this.loading = [];
        this.campaignType = $stateParams.campaignType;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    _createClass(CampaignsController, [{
        key: 'init',
        value: function init() {}
    }, {
        key: 'showLoading',
        value: function showLoading() {
            this.loading.push(1);
            this.$ionicLoading.show({
                template: '<spinner-advinda></spinner-advinda>'
            });
        }
    }, {
        key: 'hideLoading',
        value: function hideLoading() {
            this.loading.pop();
            if (this.loading.length === 0) this.$ionicLoading.hide();
        }
    }, {
        key: 'removeCampaign',
        value: function removeCampaign(campaign) {
            var _this = this;

            this.ApiCampaigns.deleteCampaign(campaign.campaignId).then(function (res) {
                if (res) {
                    _this.campaigns.splice(_this.campaigns.indexOf(campaign), 1);
                }
            });
        }
    }, {
        key: 'redirectToCampaignCreatePageBasedOnType',
        value: function redirectToCampaignCreatePageBasedOnType() {
            // ui-sref="campaignAdd({type:'children'})"
            if (this.campaignType == 'MOTHER_CAMPAIGN') {
                this.$state.go('motherCampaignAdd');
            } else {
                this.$state.go('campaignAdd', { type: 'children' });
            }
        }
    }, {
        key: 'onTypeChanged',
        value: function onTypeChanged(campaignType) {
            this.campaignType = campaignType;
        }
    }, {
        key: 'onTabChange',
        value: function onTabChange(type) {
            this.campaignType = type;
            this.$ionicScrollDelegate.scrollTop();
        }
    }]);

    return CampaignsController;
}();

exports.default = CampaignsController;


/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaigns.controller.js
 **/